import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { mergeCssModules, mapToCssModules } from '@emoney/kyber-helpers';
import classNames$1 from 'classnames';
import React__default from 'react';
import defaultCssModule from './less/input-group-add-on.module.less.js';

var InputGroupAddOn = function InputGroupAddOn(_ref) {
  var children = _ref.children,
      className = _ref.className,
      large = _ref.large,
      cssModuleProp = _ref.cssModule,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children", "className", "large", "cssModule"]);

  var cssModule = mergeCssModules(cssModuleProp, defaultCssModule);
  var classes = mapToCssModules(classNames$1('add-on', {
    large: large
  }), cssModule);
  return /*#__PURE__*/React__default.createElement("span", _extends({
    className: classNames$1(classes, className)
  }, restProps), children);
};

InputGroupAddOn.displayName = 'InputGroupAddOn';

export default InputGroupAddOn;
